function formatDate(dateString) {
    return `${dateString.substr(5, 2)}${dateString.substr(7, 3)}${dateString.substr(7, 1)}${dateString.substr(0, 4)}`;
}

function formatDay(dayInt) {
    // 0 - Sunday --> 6 - Saturday
    const week = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return `${week[dayInt]}`;
}

function formatTime(timeString) {
    let hour = parseInt(timeString.substr(0, 2), 10);
    switch (true) {
    case hour === 0: // Midnight 00:00 -> 12 am
        hour = 12;
        return `${hour.toString() + timeString.substr(2, 3)} am`;
    case hour === 12: // Noon 12:00 -> 12 pm
        return `${hour.toString() + timeString.substr(2, 3)} pm`;
    case (hour > 11): // Afternoon
        hour -= 12;
        return `${hour.toString() + timeString.substr(2, 3)} pm`;
    case hour < 10: // Before noon and single digits
        return `${timeString.substr(1, 4)} am`;
    default: // Bfore noon and double digits
        return `${timeString.substr(0, 5)} am`;
    }
}

function getTimeFromTimestamp(timestamp) {
    let hour = parseInt(timestamp.substr(11, 2), 10);
    switch (true) {
    case hour === 0: // Midnight 00:00 -> 12 am
        hour = 12;
        return `${hour.toString() + timestamp.substr(13, 3)} am`;
    case hour === 12: // Noon 12:00 -> 12 pm
        return `${hour.toString() + timestamp.substr(13, 3)} pm`;
    case (hour > 11): // Afternoon
        hour -= 12;
        return `${hour.toString() + timestamp.substr(13, 3)} pm`;
    case hour < 10: // Before noon and single digits
        return `${timestamp.substr(12, 4)} am`;
    default: // Before noon and double digits
        return `${timestamp.substr(11, 5)} am`;
    }
}

function sanitizeBSData(stateData) {
    if (!stateData) return null;
    const sanitary = stateData;
    try {
        sanitary.forEach((bs, i) => {
            sanitary[i].start_date = formatDate(bs.start_date);
            if (sanitary[i].end_date) {
                sanitary[i].end_date = formatDate(bs.end_date);
            }
            sanitary[i].meeting_time = `${formatDay(bs.bible_study_schedule.day_of_week)
            }s  at ${formatTime(bs.bible_study_schedule.meeting_time)}`;
            sanitary[i].recurring_type = bs.bible_study_schedule.recurring_type;
            sanitary[i].reporting_percentage = bs.reporting_percentage;
            sanitary[i].reports_missing = bs.reports_missing;
        });
    } catch (err) {
        sanitary.start_date = formatDate(stateData.start_date);
        if (sanitary.end_date) {
            sanitary.end_date = formatDate(stateData.end_date);
        }
        sanitary.meeting_time = `${formatDay(stateData.bible_study_schedule.day_of_week)
        }s  at ${formatTime(stateData.bible_study_schedule.meeting_time)}`;
        sanitary.recurring_type = stateData.bible_study_schedule.recurring_type;
        sanitary.reporting_percentage = stateData.reporting_percentage;
        sanitary.reports_missing = stateData.reports_missing;
    }
    return sanitary;
}

function sanitizeBSAData(stateData) {
    if (!stateData) return null;
    const sanitary = stateData;
    try {
        sanitary.forEach((bs, i) => {
            sanitary[i].met_on_date = formatDate(bs.met_at);
            sanitary[i].met_at_time = getTimeFromTimestamp(bs.met_at);
        });
    } catch (err) {
        sanitary.met_on_date = formatDate(stateData.met_at);
        sanitary.met_at_time = getTimeFromTimestamp(stateData.met_at);
    }
    return sanitary;
}

function filterByNullSubmitDate(state) {
    if (!state) return null;
    const sanitary = [];
    try {
        state.forEach((bsa) => {
            // Line below will include BSAs that have been submitted and are not cancelled but have new BSPs injected
            // if (bsa.submitted_at === null || (bsa.unknownParticipants.length !== 0 && bsa.cancelled === null)) {
            // If submitted_at is null
            if (bsa.submitted_at === null) {
                sanitary.push(bsa);
            }
        });
    } catch (err) {
        // if (state.submitted_at === null || (state.unknownParticipants.length !== 0 && state.cancelled === null)) {
        if (state.submitted_at === null) {
            sanitary.push(state);
        }
    }
    if (sanitary.length === 0) return null;
    return sanitizeBSAData(sanitary);
}

function reverseList(state) {
    if (!state) return null;
    const sanitary = state.slice();
    return sanitary.reverse();
}

export default {
    bibleStudies(state) {
        return sanitizeBSData(state.bibleStudies);
    },
    bibleStudyById(state) {
        return sanitizeBSData(state.bibleStudy);
    },
    bibleStudyAttendancesById(state) {
        return sanitizeBSAData(state.bibleStudyAttendances);
    },
    bibleStudyAttendancesByIdAsc(state) {
        return sanitizeBSAData(reverseList(state.bibleStudyAttendances));
    },
    unsubmittedAttendances(state) {
        return filterByNullSubmitDate(reverseList(state.bibleStudyAttendances));
    },
    error(state) {
        return state.error;
    }
};
